export const UPLOAD_IMAGE_TYPES = 'image/png,image/jpeg,image/jpg,image/webp';
export const UPLOAD_VIDEO_TYPES = 'video/*';
